import React from 'react'
import SharedNotesModal from './SharedNotesModal'

const ModalFacilityNotes = ({closeModal, facilityInfo}) => {
    const facilityName = facilityInfo?.facility_name ?? facilityInfo?.name ?? '';

    return (
        <SharedNotesModal
            closeModal={closeModal}
            entityInfo={facilityInfo}
            title={`${facilityName}: Facility Notes`}
            fetchPath='/facility_notes/facility/'
            createPath='/facility_notes/'
            createEntityKey='facility'
        />
    )
}

export default ModalFacilityNotes